import { useEffect } from 'react';
import { DmIconFast } from '../icon/dmIcon';
import css from './index.module.scss';
import { useGlobal } from '@/utils/useGlobal';
import NextImage from '@/components/NextImage';
import EFCycle from '@/components/UI/svg/delta2max/EFCycle';
import EFLeftLeaf from '@/components/UI/svg/delta2max/EFLeftLeaf';
import EFRightLeaf from '@/components/UI/svg/delta2max/EFRightLeaf';

export default function Z2() {
    const { useLang, useRouter, useState } = useGlobal();
    const { locale } = useRouter();
    const { t } = useLang(locale === 'za' ? 'delta2max.detail' : 'delta2max.teaser');
    const [isEnter, setIsEnter] = useState('enter');

    const imgSpec: any = {
        jp: '_jp',
        cn: '_cn',
    };

    useEffect(() => {
        AniContainer.create({
            asyncFromTo: [
                ['.d2x-Z2 .t-m-b', { scale: 3, opacity: 0 }, { scale: 1, opacity: 1 }, 4],
                ['.d2x-Z2 .t-l-t', { opacity: 0 }, { opacity: 1 }, 1],
                ['.d2x-Z2 .t-m-t-l', { opacity: 0 }, { opacity: 1 }, 1],
                ['.d2x-Z2 .t-m-t-r', { opacity: 0 }, { opacity: 1 }, 1],
                ['.d2x-Z2 .t-r', { opacity: 0 }, { opacity: 1 }, 1],
                ['.d2x-Z2 .last-box', { opacity: 0 }, { opacity: 1 }, 1],
                ['.d2x-Z2 .b-m .b-m-r', { opacity: 0 }, { opacity: 1 }, 1],
                ['.d2x-Z2 .b-m .b-m-l', { opacity: 0 }, { opacity: 1 }, 1],
                ['.d2x-Z2 .bottom .b-l', { opacity: 0 }, { opacity: 1 }, 1],
                ['.d2x-Z2 .t-l-b', { opacity: 0 }, { opacity: 1 }, 1],
            ],
            triggerElement: '.d2x-Z2',
            triggerHook: 1,
            offset: '0%',
            duration: 700,
            asyncTimeLine: [0, 3, 3.5, 4, 4.5, 5, 5.5, 6, 6.5, 7],
        });

        AniContainer.create({
            triggerElement: `.${css.d2xZ2} .top .t-l-b`,
            triggerHook: 1,
            offset: '0%',
            onEnter() {
                setIsEnter('enter');
            },
            onLeave() {
                setIsEnter('');
            },
        });
    }, []);

    return (
        <div
            className={`d2x-Z2 ${css.d2xZ2} GtmModuleData-section`}
            data-section-id={css.d2xZ2}
            data-section-title={t.rich('sec2_card4_text', {
                small: (text: string) => text,
                big: (text: string) => text,
            })}
        >
            <div className="sec2">
                <div className="top">
                    <div className="t-l">
                        <div className="t-l-t box">
                            {locale !== 'cn' && (
                                <NextImage
                                    webpSrc={require('@publicLocal/delta2max/teaser/pc/eu/02-4.webp')}
                                    src={require('@publicLocal/delta2max/teaser/pc/eu/02-4.png')}
                                    alt={t('sec2_card5_text')}
                                    aria-label={t('sec2_card5_text')}
                                />
                            )}
                            {locale === 'cn' && (
                                <NextImage
                                    webpSrc={require('@publicLocal/delta2max/teaser/pc/eu/02-4_cn.webp')}
                                    src={require('@publicLocal/delta2max/teaser/pc/eu/02-4_cn.png')}
                                    alt={t('sec2_card5_text')}
                                    aria-label={t('sec2_card5_text')}
                                />
                            )}
                            <div className="text">{t('sec2_card5_text')}</div>
                        </div>
                        <div className="t-l-b box">
                            <div className="text">
                                {t.rich('sec2_card6_text', {
                                    small: (text: string) => <span className="small">{text}</span>,
                                    big: (text: string) => <span className="big">{text}</span>,
                                })}
                            </div>
                            <div className={`icon ${isEnter}`}>{locale === 'fr' ? <EFCycle width="110px" height="54px" /> : <EFCycle />}</div>
                        </div>
                    </div>
                    <div className="t-m">
                        <div className="t-m-t">
                            <div className="t-m-t-l box">
                                <NextImage
                                    webpSrc={require('@publicLocal/delta2max/teaser/pc/eu/02-2.webp')}
                                    src={require('@publicLocal/delta2max/teaser/pc/eu/02-2.png')}
                                    alt={t('sec2_card2_text')}
                                    aria-label={t('sec2_card2_text')}
                                />
                                <div className="text">
                                    {t.rich('sec2_card2_text', {
                                        big: (text: string) => <span className="big">{text}</span>,
                                        gray: (text: string) => <span className="gray">{text}</span>,
                                    })}
                                </div>
                            </div>
                            <div className="t-m-t-r box">
                                <NextImage
                                    webpSrc={require('@publicLocal/delta2max/teaser/pc/eu/02-3.webp')}
                                    src={require('@publicLocal/delta2max/teaser/pc/eu/02-3.png')}
                                    alt={t('sec2_card3_text')}
                                    aria-label={t('sec2_card3_text')}
                                />
                                <div className="text">
                                    {t.rich('sec2_card3_text', {
                                        green: (text: string) => <span className="green">{text}</span>,
                                        small: (text: string) => <span className="small">{text}</span>,
                                        big: (text: string) => <span className="big">{text}</span>,
                                    })}
                                </div>
                            </div>
                        </div>
                        <div className="t-m-b box">
                            <NextImage
                                webpSrc={require('@publicLocal/delta2max/teaser/pc/eu/02-6.webp')}
                                src={require('@publicLocal/delta2max/teaser/pc/eu/02-6.png')}
                                alt={t('sec2_card4_text')}
                                aria-label={t('sec2_card4_text')}
                            />
                            <div className="text">
                                {t.rich('sec2_card4_text', {
                                    small: (text: string) => <span className="small">{text}</span>,
                                    big: (text: string) => <span className="big">{text}</span>,
                                })}
                            </div>
                        </div>
                    </div>
                    <div className="t-r box">
                        <NextImage
                            webpSrc={require(`@publicLocal/delta2max/teaser/pc/eu/02-1${imgSpec[locale] || ''}.webp`)}
                            src={require(`@publicLocal/delta2max/teaser/pc/eu/02-1${imgSpec[locale] || ''}.png`)}
                            alt={t('sec2_card1_text')}
                            aria-label={t('sec2_card1_text')}
                        />
                        <div className="text">
                            {t.rich('sec2_card1_text', {
                                green: (text: string) => <span className="green">{text}</span>,
                            })}
                        </div>
                    </div>
                </div>
                <div className="bottom">
                    <div className="b-l box">
                        {locale === 'cn' && (
                            <NextImage
                                webpSrc={require(`@publicLocal/delta2max/teaser/pc/eu/02-7.webp`)}
                                src={require(`@publicLocal/delta2max/teaser/pc/eu/02-7.png`)}
                                alt={t('sec2_card7_text')}
                                aria-label={t('sec2_card7_text')}
                            />
                        )}
                        <div className="text">{t('sec2_card7_text')}</div>
                        {locale !== 'cn' && (
                            <div className="left-icon">
                                <EFLeftLeaf />
                            </div>
                        )}
                        {locale !== 'cn' && (
                            <div className="right-icon">
                                <EFRightLeaf />
                            </div>
                        )}
                    </div>
                    <div className="b-m">
                        <div className="b-m-l box">
                            <NextImage
                                webpSrc={require('@publicLocal/delta2max/teaser/pc/eu/02-8.webp')}
                                src={require('@publicLocal/delta2max/teaser/pc/eu/02-8.png')}
                                alt={t('sec2_card8_text')}
                                aria-label={t('sec2_card8_text')}
                            />
                            <div className="text">
                                {t.rich('sec2_card8_text', {
                                    small: (text: string) => <span className="small">{text}</span>,
                                    big: (text: string) => <span className="big">{text}</span>,
                                })}
                            </div>
                        </div>
                        <div className="b-m-r box">
                            <NextImage
                                webpSrc={require('@publicLocal/delta2max/teaser/pc/eu/02-9-bg.webp')}
                                src={require('@publicLocal/delta2max/teaser/pc/eu/02-9-bg.png')}
                                alt={t('sec2_card9_text')}
                                aria-label={t('sec2_card9_text')}
                            />
                            <div className="bmr-content-box">
                                <DmIconFast />
                                <div className="text">
                                    {t.rich('sec2_card9_text', {
                                        big: (text: string) => <span className="big">{text}</span>,
                                    })}
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="b-m-r box last-box">
                        <NextImage
                            webpSrc={require('@publicLocal/delta2max/teaser/pc/eu/02-10.webp')}
                            src={require('@publicLocal/delta2max/teaser/pc/eu/02-10.png')}
                            alt={t('sec2_card10_text')}
                            aria-label={t('sec2_card10_text')}
                        />
                        <div className="text">
                            {t.rich('sec2_card10_text', {
                                green: (text: string) => <span className="green">{text}</span>,
                                big: (text: string) => <span className="big">{text}</span>,
                            })}
                        </div>
                    </div>
                </div>
                {locale === 'cn' && <p className="sec2-memo">{t('sec2_memo')}</p>}
            </div>
        </div>
    );
}
